import { render, staticRenderFns } from "./No12.vue?vue&type=template&id=59129da3&scoped=true"
import script from "./No12.vue?vue&type=script&lang=js"
export * from "./No12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59129da3",
  null
  
)

export default component.exports